export const environment = {
	production: true,
	primeLicense: 'eyJpZCI6IjI1N2ZlNzVhLTRkYmYtNGFmYS1hYTEzLTlmNmU0MDIxZGIwOCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3OTE4OTEyNjgsImV4cCI6MTgyMzQyNzI2OH0.pgts_G9n81ek7PoOiBt-dDrFXApXsffYWsdF8tk7jq8tmlGho6Leep7JI5tco4yL5vJtJpWaho0wMYdFOi2CAA',
	apiUrl: '/api/',
    b2cUrl: '/b2c/v1',
    apiPlenion: '/api/v1',
	apiPlenionKey: 'AIzaSyBZcmahbUek-TLyOjX5WHhnNVEDmfoe2nM',
	apiUrlHost: 'https://dev-api-services.plenion247.eu',
	mapsApiKey: 'AIzaSyCghRwR3TJhyUa7rGenei2qmcUGEj9m3n8',
	portalUrl: 'https://dev-maps.plenion247.eu/',
	version: '0.9.6'
};